import angular from 'angular';
import uiRouter from 'angular-ui-router';
import dynamicLinkEditPageComponent from './dynamicLinkEditPage.component';

let dynamicLinkEditPageModule = angular.module('dynamicLinkEditPage', [
  uiRouter
])

.component('dynamicLinkEditPage', dynamicLinkEditPageComponent)

.name;

export default dynamicLinkEditPageModule;
